import React, { useState, useEffect } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Header from '../components/Header';
import Notification from './Notification';
import Manage from './Manage';
import Attend from './Attend';
import A from './A';
import Invoice from './Invoice';
import Downloads from './Downloads';
import Container from './Container';
import TeacherDeployment from './TeacherDeployment';
import StudentCertificate from './StudentCertificate';
import TimeTable from './TimeTable';
import axios, { decryptData } from '../Axiosinstance';
import { useParams, useNavigate } from 'react-router-dom';
import Recordings from './Recordings';
import Marksheet from './Marksheet';
import { Button, Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FinHeader from '../Finance/Fheader';

function Managebatch() {
  const [tabValue, setTabValue] = useState(0);
  const [isMobileView, setIsMobileView] = useState(false);
  const { batchId, intakeId } = useParams();
  const [batchDetails, setBatchDetails] = useState(null);




  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    localStorage.setItem('activeTab', newValue);
  };

  const handleDropdownChange = (event) => {
    setTabValue(event.target.value);
    localStorage.setItem('activeTab', event.target.value);
  };

  const handleResize = () => {
    if (window.innerWidth <= 600) {
      setIsMobileView(true);
    } else {
      setIsMobileView(false);
    }
  };
  console.log("hi", intakeId);
  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Fetch batch details
    const fetchBatchDetails = async () => {
      try {
        const response = await axios.get(`batch/${decryptData(decodeURIComponent(batchId))}`);
        setBatchDetails(response.data);
      } catch (error) {
        console.error('Error fetching batch details:', error);
      }
    };

    fetchBatchDetails();
  }, [batchId]);


  useEffect(() => {
    // Retrieve active tab index from localStorage on page load
    const storedTab = localStorage.getItem('activeTab');
    if (storedTab !== null) {
      setTabValue(parseInt(storedTab)); // Parse storedTab to integer
    }
  }, []);

  if (!batchDetails) {
    return <p>Loading...</p>;
  }

  const usertype = localStorage.getItem("usertype");

  return (
    <div>
      <div>
        <div>
          {usertype === '3' || usertype === '4' ? (
            <Header />
          ) : usertype === '6' ? (
            <FinHeader />
          ) : (
            null
          )}


          <br />
        </div>
        <br />
      </div>


      {isMobileView ? (
        <div>
          {usertype === '6' ? (
            <h2
              className="heading"
              align="center"
              style={{ color: "#FFFFFF", fontSize: "28px", width: '100%' }}
            >
              Manage Student
            </h2>) : (
            <Select value={tabValue} onChange={handleDropdownChange} displayEmpty style={{ margin: '27px' }}>
              <MenuItem value="" disabled>
                Select an option
              </MenuItem>
              <MenuItem value={0}>Manage Student</MenuItem>
              {/* <MenuItem value={1}>Notification</MenuItem> */}
              <MenuItem value={1}>Attendance</MenuItem>
              <MenuItem value={2}>Recordings</MenuItem>
              <MenuItem value={3}>Teacher Deployment</MenuItem>
              <MenuItem value={4}>Time Table</MenuItem>
              <MenuItem value={5}>Certificates</MenuItem>
              <MenuItem value={6}>Marksheet</MenuItem>
              {/* <MenuItem value={4}>Assessment</MenuItem> */}
              {/* <MenuItem value={5}>Invoice</MenuItem> */}
              {/* <MenuItem value={6}>Download</MenuItem> */}
            </Select>
          )}

          {/* Wrap the Select and Container in a container div with styling */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

          </div>


          <div>
            <Container batchDetails={batchDetails} />
            {usertype === '6' ? (
              <Manage batchDetails={batchDetails} intakeId={intakeId} />
            ) : (
              <>
                {tabValue === 0 && <Manage batchDetails={batchDetails} intakeId={intakeId} />}
                {/* {tabValue === 1 && <Notification />} */}
                {tabValue === 1 && <Attend intakeId={intakeId} />}
                {/* {tabValue === 4 && <A  batchDetails={batchDetails}/>} */}

                {tabValue === 2 && <Recordings />}
                {tabValue === 3 && <TeacherDeployment intakeId={intakeId} />}
                {tabValue === 4 && <TimeTable intakeId={intakeId} />}
                {tabValue === 5 && <StudentCertificate intakeId={intakeId} />}
                {tabValue === 6 && <Marksheet intakeId={intakeId} />}
                {/* {tabValue === 5 && <Invoice />} */}
                {/* {tabValue === 6 && <Downloads />} */}
              </>
            )}
          </div>
        </div>
      ) : (
        <div style={{ alignItems: 'center', marginTop: '-5%', padding: '0% 15%' }}>
          {usertype === '6' ? (
            <h2
              className="heading"
              align="center"
              style={{
                color: "#FFFFFF",
                fontSize: "28px",
                width: '100%',
                margin: '5px 16px',
              }}
            >
              Manage Student
            </h2>
          ) : (
            <Tabs value={tabValue} onChange={handleChange} aria-label="Manage-tabs"
              variant="fullWidth"
              sx={{
                "& button": {
                  borderRadius: 10,
                  color: "#555",
                  margin: '30px 5px',  // Center the tabs horizontally

                  fontSize: '12px',


                },
                "& button:hover": {
                  backgroundColor: "#eee",
                },
                "& button:active": {
                  backgroundColor: "#ddd",
                },
                "& button.Mui-selected": {
                  backgroundColor: "#007bff",
                  color: "#fff",
                },
                "& .MuiTabs-indicator": {
                  display: 'none', // Remove the underline
                },
              }}
            >

              <Tab label="Manage Student" />
              {/* <Tab label="Notification" /> */}
              <Tab label="Attendance" />
              <Tab label="Recordings" />
              <Tab label="Teacher Deployment" />
              <Tab label="Time Table" />
              <Tab label="Certificates" />
              <Tab label="Marksheet" />
              {/* <Tab label="Invoice" /> */}
              {/* <Tab label="Download" /> */}
            </Tabs>
          )}

          {/* Wrap the Tabs and Container in a container div with styling */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>


            <Container batchDetails={batchDetails} />
            {usertype === '6' ? (
              <Manage batchDetails={batchDetails} intakeId={intakeId} />
            ) : (
              <>
            {tabValue === 0 && <Manage batchDetails={batchDetails} intakeId={intakeId} />}
            {/* {tabValue === 1 && <Notification />} */}
            {tabValue === 1 && <Attend intakeId={intakeId} />}
            {/* {tabValue === 4 && <A  batchDetails={batchDetails}/>} */}
            {tabValue === 2 && <Recordings />}
            {tabValue === 3 && <TeacherDeployment intakeId={intakeId} />}
            {tabValue === 4 && <TimeTable intakeId={intakeId} />}
            {tabValue === 5 && <StudentCertificate intakeId={intakeId} />}
            {tabValue === 6 && <Marksheet intakeId={intakeId} />}
            </>
            )}
            {/* {tabValue === 5 && <Invoice />} */}
            {/* {tabValue === 6 && <Downloads />} */}

          </div>
        </div>
      )}
    </div>
  );
}


export default Managebatch;



